import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para quién es El Acelerador 24H?',
  a: 'Para mujeres (y hombres) de entre 30 y 60 años que quieren adelgazar sin complicarse la vida, que tienen poco tiempo para cocinar y que ya tienen (o quieren tener) una Airfryer en casa.'
}, {
  q: '¿Necesito tener experiencia cocinando?',
  a: 'No. Las recetas del sistema están diseñadas para personas que no saben cocinar. Si sabes encender la Airfryer, puedes hacer cualquier receta del Tomo I.'
}, {
  q: '¿Funciona con cualquier modelo de Airfryer?',
  a: 'Sí. El Bono #1 incluye una tabla de ajustes por marca y potencia compatible con todos los modelos vendidos en España (Cosori, Philips, Ninja, Cecotec, Tefal, Moulinex y más).'
}, {
  q: '¿Cuánto tiempo tarda en verse el resultado?',
  a: 'La mayoría de nuestras usuarias reportan la primera bajada de báscula entre el día 2 y el día 4. La pérdida de cintura visible suele ocurrir entre el día 5 y el día 10. La pérdida media el primer mes es de 3 a 6kg.'
}, {
  q: '¿Tengo que hacer ejercicio?',
  a: 'No es necesario para que el sistema funcione. Está diseñado para personas sedentarias o con actividad moderada. Si haces ejercicio, los resultados se aceleran.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después del pago. Recibes un email con el enlace de descarga en menos de 2 minutos.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía total. Si no estás satisfecha por cualquier motivo, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Es un pago único o una suscripción?',
  a: 'Pago único. Pagas una vez y el contenido es tuyo para siempre. Sin suscripciones, sin cuotas mensuales, sin sorpresas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-warmWhite py-20 px-4" data-id="element-4">
      <div className="max-w-3xl mx-auto" data-id="element-5">
        <h2 className="text-3xl md:text-4xl font-heading text-center text-navy mb-12" data-id="element-6">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-7">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border-2 rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-gold bg-cream' : 'border-navy/10 bg-white'}`} data-id="element-8">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-9">
                  <span className="font-bold text-navy pr-4" data-id="element-10">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180 text-gold' : 'text-gray-400'}`} data-id="element-11" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12">
                  <p className="text-gray-700 leading-relaxed" data-id="element-13">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}